import palette from 'src/theme/adminTheme/palette';
import typography from 'src/theme/adminTheme/typography';

export default {
  root: {
    ...typography.body1,
    borderBottom: `1px solid ${palette.divider}`,
  },
};
